import { Link } from "gatsby";
import React from "react";
import { motion } from "framer-motion";
function Journey({ value, toNav }) {
  return (
    <motion.div
      className="journey--link"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { delay: 1.4 } }}
      exit={{ opacity: 0 }}
    >
      <Link to={`/${toNav}`}>{value}</Link>
    </motion.div>
  );
}

export { Journey };
